import { IModel, IAttribute, IViolation } from './../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { azureStorageAuthTypes } from '../../interfaces/IAuthenticationType';
import { AzureStorageLinkedService } from './azure-storage.linkedservice';
import { Credential } from '../credential/credential';

@Metamodel.model({
    name: ModelConstants.azureTableLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AzureTableStorage_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AzureTableStorage_DisplayText)
    ]
})
export class AzureTableStorageLinkedService extends AzureStorageLinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVICE_ENDPOINT: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServiceEndpoint,
        association: 'SERVICE_ENDPOINT',
        templatable: true,
    })
    public serviceEndpoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: (
                linkedservice: AzureTableStorageLinkedService,
                referencedCredential: Credential
            ): IViolation[] | undefined => {
                if (
                    linkedservice?.authenticationMethod ===
                    azureStorageAuthTypes.UserAssignedManagedIdentity &&
                    !referencedCredential
                ) {
                    return [
                        {
                            message: () =>
                                shellStringResources.Error_InvalidCredentialReferenced,
                        },
                    ];
                }
                return undefined;
            },
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    protected _getPEResourceName(): string {
        switch (this.authenticationMethod) {
            case azureStorageAuthTypes.AccountKeyAuthentication:
                return this.accountName || '';
            case azureStorageAuthTypes.MSIAuthentication:
            case azureStorageAuthTypes.UserAssignedManagedIdentity:
                if (this.serviceEndpoint?.toLowerCase().startsWith('https://')) {
                    return this.serviceEndpoint.substr(8).split('.')[0];
                }
                return '';
            case azureStorageAuthTypes.SasUriAuthentication:
                if (this.sasUri?.toLowerCase().startsWith('https://')) {
                    return this.sasUri.substr(8).split('.')[0];
                }
                return '';
            default:
                return '';
        }
    }
}
